module.exports = __webpack_public_path__ + "static/media/IMG_3218-min.e3710ecf.jpg";